<template>
  <div class="queue-preorder-wrapper">
    
    <div class="preorder-navbar">
      <!-- <Navbar @menu="toggleStatusTabs" /> -->

      <!-- <StatusTabs
        :currentTab="currentTab"
        :counters="tabsCounters"
        @switch="onTabSwitch"
        v-if="isDesktop"
      />
      <StatusTabs
        class="status-tabs"
        :currentTab="currentTab"
        :counters="tabsCounters"
        is_preorder
        @switch="onTabSwitch"
        v-else
      /> -->
      <QueueTabs 
        :currentTab="currentTab"
        :counters="tabsCounters"
        @tabChanged="onTabSwitch"
        :tabs="{
          new: {important: true},
          processing: {important: false},
          done: {important: true},
        }"/>
    </div>

    <button
      class="btn-create-order"
      @click="showOrderCreateUI"
      v-if="currentTab == 'new' && !isDesktop"
    >
      + {{ $t("queue.create_order") }}
    </button>

    <div class="preorders-list">
      <p class="text-center color-black my-4" v-if="!filteredList.length">
        {{ $t("queue.no_orders") }}
      </p>
      <div
        class="single-preorder-card mb-20"
        v-for="item in filteredList"
        :key="item._id"
      >
        <DeliveryCard
          :preorder="item"
          @accept="handlePreorderAccept"
          @close="handlePreorderClose"
          @send="handlePreorderSend"
          @cancel="showCancelUI"
          @car_time="handleDeliveryCardTime"
        />
      </div>
    </div>
    <div class="kanban-row">
      <div
        v-for="(column, index) in desktopPreorderList"
        :key="index"
        class="kanban-column"
      >
        <p class="text-center color-black" v-if="!column.length">
          {{ $t("queue.no_orders") }}
        </p>
        <div v-for="item in column" :key="item._id">
          <DeliveryCard
            :preorder="item"
            @accept="handlePreorderAccept"
            @close="handlePreorderClose"
            @send="handlePreorderSend"
            @cancel="showCancelUI"
            @car_time="handleDeliveryCardTime"
          />
        </div>
      </div>
    </div>

    <RefuseModal
      @cancel="hideCancelUI"
      @confirm="handlePreorderCancel"
      :will_refund="cancel_action.will_refund"
      v-if="cancel_action.active"
    />

    <!-- <img
      src="/icons/grey-logo.svg"
      class="mx-auto mt-50 mb-5 d-block qr-logo"
      v-if="processingList.length && newList.length"
    />-->
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";
import StatusTabs from "@/components/StatusTabs";

import DeliveryCard from "@/components/delivery/DeliveryCard.vue";
import RefuseModal from "@/components/modals/RefuseModal.vue";

import QueueTabs from "@/components/QueueTabs.vue"

export default {
  data() {
    return {
      currentTab: "new",
      showStatusTabs: true,

      pollingTimer: 0,

      cancel_action: {
        active: false,
        preorder_id: null,
        will_refund: false
      },
    };
  },
  methods: {
    connectToQueue() {
      this.$store.dispatch("preorder/fetchPreorders");
    },
    onTabSwitch(tab) {
      this.currentTab = tab;
    },
    handlePreorderAccept(id, waiting_time) {
      this.$store.dispatch("preorder/acceptPreorder", {
        id,
        waiting_time,
      }).finally(() => {
        if (this.filteredList.length <= 1) {
          this.onTabSwitch("processing");
        }
      });
    },
    handlePreorderClose(id) {
      this.$store.dispatch("preorder/closePreorder", id);
    },
    handlePreorderSend(id) {
      this.$store.dispatch("preorder/sendPreorder", id).finally(() => {
        if (this.filteredList.length <= 1) {
          this.onTabSwitch("done");
        }
      });
    },
    handleDeliveryCardTime(id, time) {
      this.$store.dispatch("preorder/orderCar", {
        id,
        time,
      });
    },
    toggleStatusTabs() {
      this.showStatusTabs = !this.showStatusTabs;
    },
    showCancelUI(id) {
      this.cancel_action.active = true;
      this.cancel_action.preorder_id = id;

      const preorder = this.preorders.find(p => p._id == id);
      this.cancel_action.will_refund = preorder ? preorder.pay_method == 'online' : false;
    },
    handlePreorderCancel(reason) {
      this.$store.dispatch("preorder/cancelPreorder", {
        id: this.cancel_action.preorder_id,
        reason,
      });

      this.cancel_action.active = false;
    },
    hideCancelUI() {
      this.cancel_action.active = false;
    },
    showOrderCreateUI() {
      this.$router.push('/create_delivery');
    }
  },
  mounted() {
    this.connectToQueue();
    this.pollingTimer = setInterval(this.connectToQueue, 10 * 1000);
    // this.$store
    //   .dispatch("init")
    //   .then(ok => {
    //     this.connectToQueue();
    //     this.pollingTimer = setInterval(this.connectToQueue, 10 * 1000);
    //   })
    //   .catch(error => {
    //     console.log(error);
    //     this.$router.push("/login");
    //   });
  },
  beforeDestroy() {
    clearInterval(this.pollingTimer);
  },
  computed: {
    desktopPreorderList() {
      let confirmed = [];
      let unpaid = [];
      let serving = [];
      this.preorders.forEach((el) => {
        switch (el.status) {
          case "confirmed":
            confirmed.push(el);
            break;
          case "unpaid":
            unpaid.push(el);
            break;
          case "serving":
            serving.push(el);
            break;
          default:
            break;
        }
      });
      return [confirmed, serving, unpaid];
    },
    filteredList() {
      if (this.currentTab == "new")
        return this.preorders.filter((preorder) => {
          return preorder.status == "confirmed";
        });

      return this.preorders
        .filter((preorder) => {
          if (this.currentTab == "done") {
            return preorder.status == "unpaid";
          } else {
            return preorder.status == "serving";
          }
        })
        .sort((a, b) => {
          const keyA = new Date(a.serve_date);
          const keyB = new Date(b.serve_date);

          if (keyA < keyB) return -1;
          if (keyA > keyB) return 1;
          return 0;
        });
    },

    newList() {
      return this.preorders.filter((preorder) => {
        return preorder.status === "confirmed";
      });
    },
    processingList() {
      return this.preorders.filter((preorder) => {
        return preorder.status === "serving" || preorder.status == "unpaid";
      });
    },

    tabsCounters() {
      return {
        new: this.preorders.filter((o) => o.status === "confirmed").length,
        processing: this.preorders.filter((o) => o.status === "serving").length,
        done: this.preorders.filter((o) => o.status === "unpaid").length,
      };
    },
    isDesktop() {
      return window.innerWidth > 767;
    },
    //
    // Vuex Mapping
    //
    preorders() {
      if (this.isDesktop) {
        return this.$store.state.preorder.preorders.filter(
          (p) => p.is_delivery
        );
      } else {
        //  return this.$store.state.preorder.preorders;
        return this.$store.getters["preorder/deliveriesOnly"];
      }
    },
  },
  components: {
    Navbar,
    StatusTabs,
    RefuseModal,
    DeliveryCard,
    QueueTabs
  },
};
</script>

<style scoped>
.queue-preorder-wrapper {
  background: #ededed;
  padding-bottom: 16vh;
}

.preorder-navbar {
  position: fixed;
  width: 100%;
  z-index: 2;
  top: 6.5vh;
}

.preorders-list {
  /* width: 100vw; */
  margin: 0 auto;
  padding-top: 2.5vh;
}
.preorders-list-desktop {
  display: none;
}

.qr-logo {
  margin-top: 5vh;
}

.btn-create-order {
  margin: 0 auto 0;
  width: 90%;
  font-size: 4.3vw;
  color: #1d1d1d;
  line-height: normal;
  font-weight: 500;
  display: block;
  padding: 1.5vh 0;
  border: 1px solid #1d1d1d;
  background: transparent;
  border-radius: 5vh;
}

@media (min-width: 768px) {
  .preorders-list {
    display: none;
  }
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
  }
  html {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .queue-preorder-wrapper {
    padding-bottom: 0;
  }
  
  div.newList-preorder-card {
    height: 200px;
  }

   
  div.preorders-list-desktop .newList-preorder:nth-child(2n) {
    border-left: 0.069vw solid #c4c4c4;
    border-right: 0.069vw solid #c4c4c4;
  }
  p.text-center {
    margin:0;
    font-size: 1.111vw;
  }
}
</style>
